export const SHOPPING_ASSISTANT_GREETING =
  "Welcome! I'm your NowUTalk personal shopping assistant. What are you shopping for today?";
